import React, { useRef, useEffect } from 'react';
import {
  Card,
  SummaryLayout,
  useResponsiveParams,
  Text,
} from 'quanta-ui';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
// import { PRODUCT_TYPE_LIST } from '../fire/queries';
import { PRODUCT_TYPE_LIST } from './queries';
// import {
//   Layout,
//   ClientService,
//   Loading,
//   Error,
// } from '../../../../lib/layout';
import { Layout,
  ClientService,
  Loading,
  Error, } from 'quanta-flows/modules/layout';
import FireSummaryPanel from './summary-panel';
import FireWizardPanel from './wizard-panel';

export default function NewFirePolicyIssuanceSA({
  startStep,
  isProposalNumberGenerated,
  customerID,
  lobCode,
  lobName,
  productName,
  planName,
  planCode,
  productCode,
  proposalNumber,
  stepsDisabled,
  breadcrumbNav,
}) {
  let nav = ['Quote', 'Buy Policy'];

  const product_name = productName
    ? productName
    : useParams().product_name;
  const product_code = productCode
    ? productCode
    : useParams().product_code;

  const lob_code = lobCode ? lobCode : useParams().lob_code;
  // const quote_number = quoteNumber ? quoteNumber : undefined;
  const lob_name = lobName ? lobName : useParams().lob_name;
  const ipaFormRef = useRef();

  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  const { loading, error, data } = useQuery(PRODUCT_TYPE_LIST, {
    fetchPolicy: 'cache-first',
  });

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error error={error} />;
  }

  const { lobProductList } = data;
  return (
    <Layout
      nav={breadcrumbNav ? breadcrumbNav : nav}
      service_type={ClientService}
      title={`Your ${product_name} Quote`}
    >
      {lobProductList
        ?.find(
          (lob) =>
            lob?.lob_code?.toString()?.toLowerCase() ===
            lob_code?.toString()?.toLowerCase(),
        )
        // ?.products?.find(
        //   (product) =>
        //     product?.product_code?.toString()?.toLowerCase() ===
        //       product_code?.toString()?.toLowerCase() &&
        //     product?.product_name?.toString()?.toLowerCase() ===
        //       product_name?.toString()?.toLowerCase(),
        // ) 
        ? (
        <div className="min-h-screen">
          <SummaryLayout
            summary={
              <FireSummaryPanel
                lobCode={lob_code}
                lobName={lob_name}
                productName={product_name}
                productCode={product_code}
                proposalNumber={proposalNumber}
              />
            }
          >
            <FireWizardPanel
              startStep={startStep}
              isProposalNumberGenerated={isProposalNumberGenerated}
              lobCode={lob_code}
              lobName={lob_name}
              customerID={customerID}
              productName={product_name}
              productCode={product_code}
              proposalNumber={proposalNumber}
              stepsDisabled={stepsDisabled}
            />
          </SummaryLayout>
          <div className="bg-neutral sticky bottom-0 p-3 -mx-4 mt-2 -mb-4 xl:hidden z-40">
            <FireSummaryPanel
              lobCode={lob_code}
              lobName={lob_name}
              productName={product_name}
              productCode={product_code}
              proposalNumber={proposalNumber}
            />
          </div>
        </div>
      ) : (
        <Card className="h-screen" severity={`error`}>
          <Text
            severity={'error'}
            className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
          >
            Given Lob/Product Information is not Available or Invalid
          </Text>
        </Card>
      )}
    </Layout>
  );
}
